<template>
  <solide ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled"
          @fail="onFail" @refresh="onRefresh" :slider-text="text" :imgs="imgs" :accuracy="accuracy">
  </solide>

</template>

<script>
import solide from "../tools/solide"


export default {
  name: 'Silder',
  components: {
    solide
  },
  data () {
    return{
      msg: '',
      text: '向右滑动->',
      imgs: [
        img0,
        img1
      ],
      loginBtn: false,
      accuracy: 1, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      formLabelAlign: {},
    }
  },
  methods:{
    onSuccess (times) {
      // console.log('验证通过');
      this.loginBtn = true;
      this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`;
    },
    onFail () {
      // console.log('验证不通过');
      this.msg = ''
    },
    onRefresh () {
      // console.log('点击了刷新小图标');
      this.msg = ''
    },
    onFulfilled () {
      // console.log('刷新成功啦！');
    },
    onAgain () {
      // console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.handleClick();
    },
    handleClick () {
      this.$refs.slideblock.reset();
      this.msg = ''
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_view{
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
}
.form_view{
  margin: auto;
  width: 500PX;
}
/deep/ label{
  margin-bottom: 0PX;
}
/deep/ .el-form-item__label{
  text-align:left !important;
}
/deep/ .el-form-item{
  margin-bottom: 10PX !important;
}
/deep/ .el-card{
  background-color:rgb(242,242,242);
}
.el-card__body, /deep/.el-main{
  padding: 30PX !important;
}
.title_span{
  padding-left: 5PX;
  font-size: 20PX;
  font-weight: bold;
}
.yinsi{
  line-height: 43PX;
  text-align: left;
}
.last_opt{
  margin-bottom: 10PX;
}
.select_btn{
  width: 100%;
}
.input_captch{
  flex: 1;
  padding-right: 10PX;
}
.cap_desc{
  width: 120PX;
}
.form_title{
  color: black;
  font-size: 16PX;
}
.last_btn{
  margin-top: 10PX;
}
.title_cummins{
  display: flex;
  align-items: center;
  justify-content:center;
  padding-bottom: 20PX;
}
@media screen and (max-width: 768px) {
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 100%; /* 移动端占满屏幕宽度 */
    margin: 0;
  }

}
@media (device-height:480px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone4/4s */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 100%; /* 移动端占满屏幕宽度 */
    margin: 0;
  }
}

@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 100%; /* 移动端占满屏幕宽度 */
    margin: 0;
  }
}

@media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 100%; /* 移动端占满屏幕宽度 */
    margin: 0;
  }
}
@media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 Plus */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 100%; /* 移动端占满屏幕宽度 */
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue